// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';

export const ArticlePreview = (el) => {
  const ui = {
    el,
    body: select('body', document),
    articleContainer: select('.articles', document),
    firstOfType: select('.article-preview:first-of-type'),
    allArticles: select.all('.article-preview', document),
    oddArticles: select.all('.article-preview:nth-child(odd):not(:first-of-type)'),
  };

  console.log(ui.oddArticles);

  const removeFeaturedFromArticles = () => {
    ui.allArticles.forEach(article => {
      article.removeAttribute('data-theme');
    });
  }

  const setFeatured = () => {
    // set the first post to be visually featured
    if (ui.firstOfType) {
      if (!ui.firstOfType.getAttribute('data-theme')) {
        removeFeaturedFromArticles();
        ui.firstOfType.setAttribute('data-theme', 'black');
      }
    }
  }

  const setStriping = () => {
    if (ui.oddArticles) {
      ui.oddArticles.forEach(oddboy => {
        oddboy.setAttribute('data-theme', 'gray');
      });
    }
  }

  const addEvents = () => {
    setFeatured();
    setStriping();
  }

  const init = () => {
    addEvents();
  };

  init();
};

export default ArticlePreview;
